export default {
  host: process.env.VUE_APP_HOST ||  "https://merchant.caomeijuan.cn/merchant/", // 默认值为生产环境的 HOST"http://192.168.5.35:8081",
  mpHost: process.env.VUE_APP_MPHOST || "https://mpdev.caomeijuan.cn/mp-serve-api/",
  JD_HOST : process.env.VUE_APP_JD_HOST || "https://mp.caomeijuan.cn/gs-serve-api/", // 默认值为生产环境的 HOST
  chatUrl: process.env.VUE_APP_CHAT || "https://chat.inwuoo.com", // 默认值为生产环境的 chatUrl
  clientUrl: process.env.VUE_APP_CLIENT || "https://client.inwuoo.com", // 默认值为生产环境的 clientUrl
  IMG_URL:process.env.VUE_APP_IMG || "https://mini-template.oss-cn-hangzhou.aliyuncs.com/", // 默认值为生产环境的 HOST,
  mpUrl:process.env.VUE_APP_MP || "https://mp.caomeijuan.cn",
  miniSystemUrl:process.env.VUE_APP_MINISYSTEM || "https://mp.caomeijuan.cn",
  jdUrl:process.env.VUE_APP_JD || "https://mp.caomeijuan.cn",
  jdAdmin:process.env.VUE_APP_JD_ADMIN || "https://gs.inwuoo.com/",
  n8n:process.env.VUE_APP_N8N || "https://n8n.inwuoo.com/webhook/"
}